import PersonaNotasView from "./PersonaNotasView";

export {PersonaNotasView}
export default PersonaNotasView
